export default "__VITE_ASSET__DARxmV9s__"